import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="pt-24 pb-20 bg-dark-900">
            <div className="container px-4 mx-auto">
                <div className="mx-auto max-w-4xl">
                    <h1 className="mb-8 text-4xl font-bold text-white">Privacy Policy</h1>

                    <div className="prose prose-invert">
                        <p className="mb-6 text-dark-300">Last updated: 30/04/2025</p>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Information We Collect</h2>
                            <p className="mb-4 text-dark-300">
                                We only collect the minimum amount of information necessary to provide our services:
                            </p>
                            <ul className="pl-6 mb-6 list-disc text-dark-300">
                                <li>Email address (for account creation and communication)</li>
                                <li>License key information</li>
                                <li>Payment information (processed securely by our payment provider)</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">How We Use Your Information</h2>
                            <p className="mb-4 text-dark-300">
                                Your information is used solely for:
                            </p>
                            <ul className="pl-6 mb-6 list-disc text-dark-300">
                                <li>Managing your WinMax Optimizer license</li>
                                <li>Providing customer support</li>
                                <li>Sending important service updates</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Data Security</h2>
                            <p className="mb-4 text-dark-300">
                                We implement industry-standard security measures to protect your data. Your information
                                is encrypted in transit and at rest.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="mb-4 text-2xl font-semibold text-white">Your Rights</h2>
                            <p className="mb-4 text-dark-300">
                                You have the right to:
                            </p>
                            <ul className="pl-6 mb-6 list-disc text-dark-300">
                                <li>Access your personal data</li>
                                <li>Export your data</li>
                                <li>Request deletion of your data</li>
                                <li>Opt-out of marketing communications</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="mb-4 text-2xl font-semibold text-white">Contact Us</h2>
                            <p className="text-dark-300">
                                If you have any questions about our privacy policy, please contact us at{' '}
                                <a href="mailto:privacy@winmaxoptimizer.com" className="text-primary-400 hover:text-primary-300">
                                    support@winmaxoptimizer.com
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
